// @flow

// Operator State
import { initialState as operatorState } from 'hfty-operator-asset-migrate'

export default {
  ...operatorState,
}
